export enum ResponsiveCalendarViewType {
  ListWeek = 'listWeek',
  DayGridWeek = 'dayGridWeek',
  DayGridMonth = 'dayGridMonth',
}
